import { haveValue } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";
import { Button, Icon, Modal } from "../../components/design";
import styles from "./ApplicationCreatedModal.module.css";

// isGuarantor / hideBackgroundImage only changed the old overlay background;
// the shared Modal has one backdrop for everyone.
const ProcessPassedModal = ({
  showPopup,
  isGuarantor, // eslint-disable-line no-unused-vars
  heading,
  subheading,
  buttonText,
  handleClick,
  hideBackgroundImage, // eslint-disable-line no-unused-vars
}) => {
  const { _t } = useTranslator();
  return (
    <Modal
      open={!!showPopup}
      onClose={handleClick}
      dismissible={false}
      icon={
        <span className={styles.check}>
          <Icon name="check" size={28} />
        </span>
      }
      title={heading}
      description={subheading}
      actions={
        <Button size="lg" block onClick={handleClick}>
          {haveValue(buttonText) ? _t(buttonText) : _t("done&GoBack")}
        </Button>
      }
    />
  );
};

export default ProcessPassedModal;
